import { render, staticRenderFns } from "./back.vue?vue&type=template&id=1a50fb2c&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"
import style0 from "./back.vue?vue&type=style&index=0&id=1a50fb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50fb2c",
  null
  
)

export default component.exports